#import "../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql"
#import "../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

mutation InvoiceEmailCreate($input: InvoiceEmailCreateInput!) {
  invoiceEmailCreate(input: $input) {
    invoiceEmail {
      _emailDocument {
        ...EmailDocumentFields
      }
      emailDocumentsByEntityId(orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]) {
        nodes {
          ...EntityEmailDocumentsFields
        }
      }
    }
  }
}
